<template>
  <div class="dashboard-container flex flex-wrap flex-col">
    <SmartTitle heading="1" weight="bold" class="mt-0 mx-1"> Novo Smart </SmartTitle>
    <SmartRow class="mx-auto">
      <SmartIconDash v-for="service in items" :key="service.label" v-bind="service"
        @click.native="changeRoute(service.name, service)" class="lg:col-4 md:col-4 sm:col-12 flex flex-wrap"
        :id="service.id" />
    </SmartRow>
    <SmartSkeletonLoading v-if="checkingLegados" :height="3" />
    <SmartTitle heading="1" class="mt-2" v-else-if="itemsLegado.length">
      Sistemas Legados
    </SmartTitle>
    <SmartRow class="mx-auto">
      <SmartButtonDash v-for="(report, index) in itemsLegado" :key="index" v-bind="report"
        @click.native="chamaLegado(report)" class="lg:col-4 md:col-4 sm:col-12 flex flex-wrap" />
    </SmartRow>
    <SmartModal v-if="modal" v-bind="modal" @close="modal = null">
      {{ modal.text }}
    </SmartModal>

    <div class="icons__wrapper mt-5 ml-2 text-center">
      <a class="mr-2" target="blank" :href="linkAndroid">
        <img width="135px" height="40px" src="../../assets/images/store-icons/play_store_download.png" />
      </a>
      <a :href="linkIOS" target="blank">
        <img width="135px" height="40px" src="../../assets/images/store-icons/app_store_download.png" />
      </a>
    </div>
  </div>
</template>

<script>
import dashboardMenuItem from 'constants/dashboardMenuItem';
import dashboardMenuItemLegado from 'constants/dashboardMenuItemLegado';
import { mapGetters, mapActions } from 'vuex';
import BrowserStorage from '@/services/browser-storage';

export default {
  data() {
    return {
      modal: null,
      checkingLegados: false,
      legados: JSON.parse(JSON.stringify(dashboardMenuItemLegado)),
      linkIOS: process.env.VUE_APP_IOS_URL,
      linkAndroid: process.env.VUE_APP_ANDROID_URL
    };
  },
  computed: {
    ...mapGetters({
      webPermission: 'auth/webPermission',
      token: 'auth/getToken'
    }),
    items() {
      return dashboardMenuItem.filter(item =>
        this.webPermission.find(p => p.name === item.permission)
      );
    },
    itemsLegado() {
      return this.legados;
    }
  },
  watch: {},
  async mounted() {
    const pluck = (arr, key) => arr.map(i => i[key]);

    (this.linkIOS = process.env.VUE_APP_IOS_URL),
      (this.linkAndroid = process.env.VUE_APP_ANDROID_URL);

    let legadoAfterCheck = [];

    this.itemsLegado.map((item, index) => {
      if (pluck(this.webPermission, 'name').includes(item.permission)) {
        item.loading = true;

        legadoAfterCheck.push(item);

        this.checkAllowedSystem(item.idSystem)
          .then(() => {
            item.loading = false;
          })
          .catch(() => {
            legadoAfterCheck.map((i, index) => {
              if (item.idSystem === i.idSystem) {
                legadoAfterCheck.splice(index, 1);
              }
            });
          });
      }
    });

    this.legados = legadoAfterCheck;
  },
  methods: {
    ...mapActions({
      setItems: 'breadcrumbs/setItems',
      checkAllowedSystem: 'auth/checkAllowedSystem'
    }),
    changeRoute(routerName, service) {
      if (routerName === 'Visit2') {
        const token = BrowserStorage.get('token');
        if (token == null) {
          alert('Token não encontrado, favor logar novamente.');
          this.$router.push('/');
          return;
        }
        window.open(`${process.env.VUE_APP_VISITS2_LINK}?token=${token}`, '_self');
        return;
      }
      if (routerName === 'hierarchies') {
        const token = BrowserStorage.get('token');
        if (token == null) {
          alert('Token não encontrado, favor logar novamente.');
          this.$router.push('/');
          return;
        }
        window.open(`${process.env.VUE_APP_HIERARCHIES_LINK}?token=${token}`, '_self');
        return;
      }
      if (routerName === 'wallets') {
        const token = BrowserStorage.get('token');
        if (token == null) {
          alert('Token não encontrado, favor logar novamente.');
          this.$router.push('/');
          return;
        }
        window.open(`${process.env.VUE_APP_WALLETS_LINK}?token=${token}`, '_self');
        return;
      }
      this.$router.push({ name: routerName });
      this.setItems(service.breadcrumbs);
    },
    chamaLegado(item) {
      if (item.idSystem != null) {
        this.checkAllowedSystem(item.idSystem)
          .then(({ message }) => {
            const baseURL = process.env[item.urlENV];
            const token = BrowserStorage.get('token');
            const url = `${baseURL + item.endPoint}?token=${token}`;
            window.open(url, '_blank');
          })
          .catch(({ data }) => {
            this.modal = {
              type: 'warning',
              title: 'Atenção!',
              icon: 'alert',
              buttonText: 'Ok',
              text:
                'Você não possui perfil de acesso a esse sistema, favor entrar em contato com o suporte.'
            };
          });
      }
    }
  }
};
</script>
